__turbopack_context__.v({
  "container": "styles-module-scss-module__A0p-XG__container",
  "desktopTextFirst": "styles-module-scss-module__A0p-XG__desktopTextFirst",
  "media": "styles-module-scss-module__A0p-XG__media",
  "text": "styles-module-scss-module__A0p-XG__text",
  "textFirst": "styles-module-scss-module__A0p-XG__textFirst",
});
